module.exports = __webpack_public_path__ + "static/media/pine-wood.ea0af1d6.jpg";